import React from 'react';
import PropTypes from 'prop-types';
import ButtonComponent from '../button';
import { AuthPageHead } from '../../styles/global-styles';
import { CardSecondary, CardSecondaryContent } from './card-secondary.style';

const CardSecondaryComponent = ({ label = 'heading here', data, handleClick, hideButton }) => {
    return (
        <CardSecondary>
            {/* HEAD */}
            <AuthPageHead>
                <div className="left">
                    <h5>{label}</h5>
                </div>
                {
                    !hideButton &&
                    <div className="right">
                        <ButtonComponent label="Detailed view" size="small" outline onClick={handleClick} />
                    </div>
                }
            </AuthPageHead>

            {/* BODY */}
            {
                data && Object.entries(data).length > 0 && (
                    <CardSecondaryContent>
                        {
                            Object.entries(data)
                                .slice(0, 4)
                                .map(([key, value]) => (
                                    <p key={key}>
                                        <strong>{key}:</strong> {value !== null && value !== undefined ? String(value) : 'null'}
                                    </p>
                                ))
                        }
                    </CardSecondaryContent>
                )
            }
        </CardSecondary>
    );
};

CardSecondaryComponent.propTypes = {
    label: PropTypes.string,
    data: PropTypes.object,
    handleClick: PropTypes.func,
    hideButton: PropTypes.bool,
};

export default CardSecondaryComponent;
